export enum DECISION_MODEL_STATE_ENUMERATION {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  GRAY_ZONE = 'GRAY_ZONE',
  GZPRR = 'GZPRR',
  DECLINE = 'DECLINE',
  ON_GRAY_ZONE = 'ON_GRAY_ZONE',
  ON_GRAY_ZONE_PROCESS = 'ON_GRAY_ZONE_PROCESS',
  DECLINED = 'DECLINED',
}
